import useSWR from 'swr'

import { getAlreadyReceived, getToBeEmailed } from '../../api'
import useQuery from '../../context/useQuery'
import AlreadyReceived from './alreadyReceived'
import FirstInvoiceTabs, {
  alreadyReceivedUrl,
  isReceivedList,
  listPage,
  toBeEmailedUrl,
} from './firstInvoiceTabs'
import ToBeEmailed from './toBeEmailed'

const tabLabel = (
  title: string,
  data: { pagination?: { total: number } } | null | undefined,
  isLoading: boolean,
) => (isLoading || !data?.pagination ? title : `${title} (${data.pagination.total})`)

/**
 * Both lists stay subscribed while Robots is open, so a tab keeps its count
 * when its request finishes after a switch. Only one list is on screen.
 */
const FirstInvoiceLists = () => {
  const params = useQuery()
  const received = isReceivedList(params)
  const toBe = useSWR(toBeEmailedUrl(listPage(params, 'toPage')), getToBeEmailed)
  const already = useSWR(alreadyReceivedUrl(listPage(params, 'receivedPage')), getAlreadyReceived)

  return (
    <section className="mt-4">
      <FirstInvoiceTabs
        selected={received ? 'received' : 'to-be-emailed'}
        toBeEmailedLabel={tabLabel('To be emailed', toBe.data, toBe.isLoading)}
        alreadyReceivedLabel={tabLabel('Already received', already.data, already.isLoading)}
      />
      {received ? <AlreadyReceived showTabs={false} /> : <ToBeEmailed showTabs={false} />}
    </section>
  )
}

export default FirstInvoiceLists
